export class PaymentModalReturn {
  ReturnType: string;
  ReturnMessage: string;

  constructor(returnType: string, returnMessage: string) {
    this.ReturnType = returnType;
    this.ReturnMessage = returnMessage;
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/models/payment-modal-return.ts